import { type RouteRecordRaw } from 'vue-router'

export const authRouter: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: { name: 'auth.login' },
  },
  {
    component: async () => import('../views/LoginView.vue'),
    meta: {
      isPublic: true,
      title: 'auth.login',
    },
    name: 'auth.login',
    path: '/login',
  },
  {
    component: async () => import('../views/MultiFactorAuthSentView.vue'),
    meta: {
      isPublic: true,
      title: 'auth.multi-factor-auth',
    },
    name: 'auth.multiFactorAuth',
    path: '/multi-factor-auth',
  },
  {
    component: async () => import('../views/MultiFactorAuthSentView.vue'),
    meta: {
      isPublic: true,
      title: 'auth.multi-factor-auth-v2',
    },
    name: 'auth.multiFactorAuth.v2',
    path: '/multi-factor-auth/v2',
  },
  {
    component: async () => import('../views/MultiFactorAuthVerifyView.vue'),
    meta: {
      isPublic: true,
      title: 'auth.multi-factor-auth-verify',
    },
    name: 'auth.multiFactorAuthVerify',
    path: '/multi-factor-auth/verify',
  },
  {
    component: async () => import('../views/ForgotPasswordView.vue'),
    meta: {
      isPublic: true,
      title: 'auth.forgot-password',
    },
    name: 'auth.forgot-password',
    path: '/forgot-password',
  },
  {
    component: async () => import('../views/ResetPasswordView.vue'),
    meta: {
      isPublic: true,
      title: 'auth.reset-password',
    },
    name: 'auth.reset-password',
    path: '/reset-password',
  },
  {
    component: async () => import('../views/ResetPasswordView.vue'),
    meta: {
      isPublic: true,
      title: 'auth.reset-password',
    },
    name: 'auth.reset-password.v2',
    path: '/reset-password/v2',
  },
  {
    component: async () => import('../views/CredentialSetupView.vue'),
    meta: {
      isPublic: true,
      title: 'auth.credential-setup',
    },
    name: 'auth.credential-setup',
    path: '/credential-setup',
  },
]
